module.exports = __webpack_public_path__ + "media/images/badge-clip-rn-eafaf2cb0904e6e56941b1570312d355.svg";